import { Box, HStack } from "@chakra-ui/react";
import { format } from "date-fns";
import CDS from "design-system";

interface DayHeaderRowProps {
  date: Date;
  dayNumber?: number;
  sessionCount: number;
  isToday?: boolean;
}

/** Tinted section header inside the schedule card; the current day is highlighted as "Today". */
export default function DayHeaderRow({ date, dayNumber, sessionCount, isToday }: DayHeaderRowProps) {
  const dayLabel = dayNumber !== undefined ? ` · Day ${dayNumber}` : "";

  return (
    <HStack
      justify="space-between"
      align="center"
      px={4}
      py={2.5}
      bg="bg.subtle"
      borderY="1px solid"
      borderColor="border.subtle"
    >
      <HStack spacing={2} align="center">
        {isToday && <Box w="8px" h="8px" borderRadius="full" bg="blue.500" flexShrink={0} />}
        {isToday ? (
          <>
            <CDS.Text16 fontWeight="semibold" color="blue.600">
              Today
            </CDS.Text16>
            <CDS.Text14 color="fg.muted">
              {format(date, "EEEE, MMM d")}
              {dayLabel}
            </CDS.Text14>
          </>
        ) : (
          <>
            <CDS.Text16 fontWeight="semibold">{format(date, "EEEE")}</CDS.Text16>
            <CDS.Text14 color="fg.muted">
              {format(date, "MMM d")}
              {dayLabel}
            </CDS.Text14>
          </>
        )}
      </HStack>
      <CDS.Text12 color="fg.subtle">
        {sessionCount} {sessionCount === 1 ? "meeting" : "meetings"}
      </CDS.Text12>
    </HStack>
  );
}
